/* ============================================================================
   Where a signup actually came from.

   THE PROBLEM. Every customer created by this site was landing in the store's
   country. The forms send no address field at all, and the shop has exactly one
   market, United Kingdom, so Shopify stamps a country-only address on the
   record: countryCodeV2 GB, with city, province and zip all null. It is a store
   default wearing the costume of visitor data, and it is the same for a reader
   in Manchester and a reader in Melbourne.

   Fixing it properly means adding Markets, which changes currency, pricing,
   shipping and duties for real customers. That is a commercial decision and far
   too big a lever to pull for the sake of a segment field.

   WHAT THIS DOES INSTEAD. Reads the browser's own IANA time zone at submit and
   sends it along. No third-party lookup, no IP service, no extra field for the
   visitor to fill in, and nothing added to the form they can see. The signup
   forms were deliberately cut to one required field; this does not spend any of
   that.

     tag   tz-europe-london          segmentable in Shopify Email
     note  TZ: Europe/London (UTC+1) readable in the admin, and the offset is
                                     what you actually want for send timing

   IT IS AN APPROXIMATION AND SHOULD BE READ AS ONE. A VPN lies, a traveller is
   temporarily wrong, and a locked-down browser may report nothing at all, in
   which case this adds nothing rather than guessing. It is still real data from
   the visitor's own machine, which is more than a store default ever was.
============================================================================ */
(function () {
  'use strict';

  function zone() {
    try {
      return (Intl.DateTimeFormat().resolvedOptions().timeZone || '').trim();
    } catch (e) {
      return '';
    }
  }

  /* Written the way a person reads an offset rather than the way JS reports it:
     getTimezoneOffset() counts minutes WEST of UTC, so it is inverted, and the
     sign has to be forced because +0 and -0 both print as "0". */
  function offset() {
    var mins = -new Date().getTimezoneOffset();
    var sign = mins < 0 ? '-' : '+';
    var abs = Math.abs(mins);
    var h = Math.floor(abs / 60);
    var m = abs % 60;
    return 'UTC' + sign + h + (m ? ':' + (m < 10 ? '0' + m : m) : '');
  }

  function slug(tz) {
    return (
      'tz-' +
      tz
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
    );
  }

  function hidden(form, name) {
    var el = form.querySelector('[name="' + name + '"]');
    if (el) return el;
    el = document.createElement('input');
    el.type = 'hidden';
    el.name = name;
    form.appendChild(el);
    return el;
  }

  /* CAPTURE PHASE, so this runs before any handler that might stop the event,
     and synchronously, so the inputs are already written when the form posts. */
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.nodeName !== 'FORM') return;

      /* Customer signups only. The contact page posts to the same endpoint but
         carries contact[body] and sends a MESSAGE rather than creating a
         customer, so tagging it would put time zones on enquiries. */
      if (!form.querySelector('[name="contact[email]"]')) return;
      if (form.querySelector('[name="contact[body]"]')) return;

      var tz = zone();
      if (!tz) return; // reported nothing: add nothing

      var tag = slug(tz);
      var tags = hidden(form, 'contact[tags]');
      var have = tags.value
        .split(',')
        .map(function (t) {
          return t.trim();
        })
        .filter(Boolean);
      if (have.indexOf(tag) === -1) have.push(tag);
      tags.value = have.join(',');

      /* Appended, never assigned. The quiz already writes the score and tier in
         here and that is the only record of either. */
      var note = hidden(form, 'contact[note]');
      var line = 'TZ: ' + tz + ' (' + offset() + ')';
      if (note.value.indexOf('TZ: ') === -1) {
        note.value = note.value ? note.value + ' · ' + line : line;
      }
    },
    true
  );
})();
